import { CircularProgress, Typography } from '@material-ui/core';
import { LoadingSpinnerIconTwoTone } from '@room-match/shared-ui-components';
import React, { useState } from 'react';
import { useSendMessage } from 'shared/hooks/useSendMessage';
import MessageItem from './MessageItem';
import { Heading, HeadingWrapper, MainContainer, MessageCont, SendButton, TextArea } from './Messaging.styles';

interface Props {
  type: 'new-audition-requests';
  id: string;
  showEmpty?: boolean;
  isTalent?: boolean;
  agent_casting?: boolean;
  projectId: string;
  messageKey: 'agent_talent_messages' | 'casting_talent_messages';
}

const Messaging: React.FC<Props> = ({ type = 'new-audition-requests', id, showEmpty, projectId, messageKey }) => {
  const [noteToSend, setnoteToSend] = useState('');
  const { send, messages, loading, sending, user } = useSendMessage({
    id: id,
    noteToSend: noteToSend,
    type: type,
    messageKey,
    projectId,
    afterSend: () => setnoteToSend(''),
  });

  if (!messages?.length && !loading && !showEmpty) return <React.Fragment />;

  return loading ? (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <LoadingSpinnerIconTwoTone style={{ width: 55, height: 55, alignSelf: 'center' }} />
    </div>
  ) : (
    <MainContainer>
      <Typography
        style={{ fontSize: 18 }}
      >{`${messageKey === 'agent_talent_messages' ? 'Agency' : 'Casting'}/Talent Notes:`}</Typography>
      <TextArea
        disabled={sending}
        value={noteToSend}
        multiline
        margin="dense"
        placeholder={'Type message here…'}
        minRows={3}
        onChange={(e) => setnoteToSend(e.target.value)}
        InputProps={{
          endAdornment: (
            <SendButton fullWidth variant="contained" color="primary" disabled={!noteToSend || sending} onClick={send}>
              {sending ? <CircularProgress style={{ width: 30, height: 30 }} /> : 'Send'}
            </SendButton>
          ),
        }}
      />
      {showEmpty && messages?.length ? (
        <HeadingWrapper>
          <Heading>Notes History:</Heading>
          <Typography style={{ fontSize: 14, color: 'darkgray', position: 'absolute', top: 3, right: 0 }}>
            {messages?.length} Total Notes
          </Typography>
        </HeadingWrapper>
      ) : (
        <React.Fragment />
      )}
      <MessageCont>
        {(messages || [])
          .sort((a, b) => (parseInt(a.timestamp) < parseInt(b.timestamp) ? 1 : -1))
          .map((m) => (
            <MessageItem message={m} me={m.sender === user.id} />
          ))}
      </MessageCont>
    </MainContainer>
  );
};

export default Messaging;
